/**
 * API client for system setting administration.
 */

import api from '../utils/axios';
import type {
  SearchEngineModeSwitchRequest,
  SearchEngineModeSwitchResponse,
  SystemSettingResponse,
  UpdateSystemSettingRequest,
} from '../types/systemSettings.types';

export const systemSettingsService = {
  /**
   * Loads admin-facing system settings.
   */
  async getSystemSettings(): Promise<SystemSettingResponse[]> {
    const response = await api.get<SystemSettingResponse[]>('/admin/system-settings');
    return response.data;
  },

  /**
   * Updates a typed system setting.
   */
  async updateSystemSetting(
    key: string,
    data: UpdateSystemSettingRequest
  ): Promise<SystemSettingResponse> {
    const response = await api.put<SystemSettingResponse>(
      `/admin/system-settings/${key}`,
      data
    );
    return response.data;
  },

  async getSearchEngineModeStatus(): Promise<SearchEngineModeSwitchResponse> {
    const response = await api.get<SearchEngineModeSwitchResponse>(
      '/admin/search-index/mode'
    );
    return response.data;
  },

  async switchSearchEngineMode(
    data: SearchEngineModeSwitchRequest
  ): Promise<SearchEngineModeSwitchResponse> {
    const response = await api.put<SearchEngineModeSwitchResponse>(
      '/admin/search-index/mode',
      data
    );
    return response.data;
  },
};
